import { render, staticRenderFns } from "./VisitaControlloEcgViewComponent.vue?vue&type=template&id=7609afd5"
import script from "./VisitaControlloEcgViewComponent.vue?vue&type=script&lang=js"
export * from "./VisitaControlloEcgViewComponent.vue?vue&type=script&lang=js"
import style0 from "./VisitaControlloEcgViewComponent.vue?vue&type=style&index=0&id=7609afd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports